<!--
 * @Author: yuanjianlong
 * @Description: 用户协议
 * @Date: 2021-12-09 14:41:22
 * @LastEditTime: 2021-12-27 16:19:54
 * @FilePath: /teacher-h5/src/components/PrivacyPolicy.vue
-->
<template>
  <a-modal
    :visible="visible"
    title="爱学习隐私权政策"
    width="796px"
    :footer="null"
    centered
    wrap-class-name="protocol-modal"
    @cancel="handleCancel"
  >
    <div class="modal-body-main">
      <p style="text-align:right; font-weight: normal;">
        <span>发布日期：</span><span>2021</span><span>年</span><span>8</span><span>月25日</span>
      </p>
      <p style="text-align:right; font-weight: normal;">
        <span>生效日期：</span><span>2021</span><span>年</span><span>8</span><span>月25日</span>
      </p>
      <p style="text-align:right; font-weight: normal;">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <a name="_Hlk65663020"><span>北京爱学习博乐教育科技有限公司（以下简称“爱学习”或“我们”）尊重并保护用户隐私，在您使用我们提供的产品和／或服务时，我们除了会按照《爱学习用户服务协议》的约定向您提供产品和／或服务外，还将按照本《爱学习隐私权政策》（以下简称“本政策”），遵循正当</span><span>、</span><span>合法</span><span>、</span><span>必要的原则，公开明示收集</span><span>、</span><span>使用您的个人信息。</span></a>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们深知个人信息对您的重要性，并会尽全力保障您的个人信息安全可控</span><span>。</span><span>本政策主要向您阐述您在使用爱学习提供的产品和／或服务过程中，我们将收集哪些信息</span><span>、</span><span>所收集信息的用途</span><span>、</span><span>您所享有的权利等，并申明了我们对保护您个人信息的承诺</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">我们未来可能根据信息处理情境的变化不时调整本政策，我们会将调整后的本政策</span><a name="_Hlk65764908"><span style="font-weight:bold">以适当的可以为您所知的方式进行公布（包括但不限于公布在官方网站</span><span style="font-weight:bold">、</span><span style="font-weight:bold">移动应用</span><span style="font-weight:bold">、</span><span style="font-weight:bold">电脑客户端等平台上），如果您不同意调整后的本政策的，您应当停止使用爱学习产品和／或服务；如果在我们调整本政策并公布后，您继续使用爱学习产品和／或服务的，则视为您同意调整后的本政策</span><span style="font-weight:bold">。</span></a>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">您理解您将通过在爱学习平台（包括但不限于爱学习所有</span><span style="font-weight:bold">、</span><span style="font-weight:bold">合法运营或授权运营的官方网站</span><span style="font-weight:bold">、</span><span style="font-weight:bold">移动应用</span><span style="font-weight:bold">、</span><span style="font-weight:bold">电脑客户端</span><span style="font-weight:bold">、</span><span style="font-weight:bold">相关微信开放平台账号或小程序</span><span style="font-weight:bold">、</span><span style="font-weight:bold">H5链接等，以下合称“爱学习平台”或“平台”）点击确认的形式（包括但不限于勾选“确认”</span><span style="font-weight:bold">、</span><span style="font-weight:bold">“同意”或表示同意本政策内容的其他类似选项，点击“确认”</span><span style="font-weight:bold">、</span><span style="font-weight:bold">“同意”</span><span style="font-weight:bold">、</span><span style="font-weight:bold">“登录”或表示同意本政策内容的其他类似按钮，以及作出其他与前述行为类似的行为）表示同意本政策，请您务必在点击确认同意本政策之前，审慎阅读</span><span style="font-weight:bold">、</span><span style="font-weight:bold">充分理解各条款内容，特别是免除或者限制我们责任的条款</span><span style="font-weight:bold">、</span><span style="font-weight:bold">法律适用和争议解决条款</span><span style="font-weight:bold">。</span><span style="font-weight:bold">免除或者限制我们责任的条款将以粗体标识，您应重点阅读</span><span style="font-weight:bold">。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则</span><span>、</span><span>目的明确原则</span><span>、</span><span>选择同意原则</span><span>、</span><span>最小必要原则</span><span>、</span><span>确保安全原则</span><span>、</span><span>主体参与原则</span><span>、</span><span>公开透明原则等</span><span>。</span><span>同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">当您点击确认同意本政策，即表示您已全面</span><span style="font-weight:bold">、</span><span style="font-weight:bold">细致</span><span style="font-weight:bold">、</span><span style="font-weight:bold">充分阅读</span><span style="font-weight:bold">、</span><span style="font-weight:bold">理解且接受本政策的全部内容，并与我们达成一致，本政策对您及我们均具有法律约束力</span><span style="font-weight:bold">。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>如您对本政策有任何疑问，可按照本政策文末列明的方式与我们取得联系</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">本政策将帮助您了解以下内容：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">一</span><span style="font-weight:bold">、</span><span style="font-weight:bold">本政策适用范围</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">二</span><span style="font-weight:bold">、</span><span style="font-weight:bold">个人信息定义及范围</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">三</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何收集和使用您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">四</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何使用Coo</span><span style="font-weight:bold">kie</span><span style="font-weight:bold">和同类技术</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">五</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何共享</span><span style="font-weight:bold">、</span><span style="font-weight:bold">转让</span><span style="font-weight:bold">、</span><span style="font-weight:bold">公开披露您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">六</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何存储您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">七</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何保护您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">八</span><span style="font-weight:bold">、</span><span style="font-weight:bold">您的权利</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <a name="_Hlk65764585"><span style="font-weight:bold">九</span><span style="font-weight:bold">、</span><span style="font-weight:bold">您的个人信息如何在全球范围转移</span></a>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="-aw-bookmark-end:_Hlk65764585" /><span style="font-weight:bold">十</span><span style="font-weight:bold">、</span><span style="font-weight:bold">本政策的修订与更新</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">十一</span><span style="font-weight:bold">、</span><span style="font-weight:bold">法律适用及争议解决</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">十二</span><span style="font-weight:bold">、</span><span style="font-weight:bold">您如何联系我们</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">一</span><span style="font-weight:bold">、</span><span style="font-weight:bold">本政策适用范围</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（一）除非您使用的爱学习产品和／或服务设有单独的隐私权政策，否则本政策适用于北京爱学习博乐教育科技有限公司通过爱学习平台提供的所有线上产品及服务</span><span>。</span><span>如您使用的爱学习产品和／或服务设有单独的隐私权政策的，则您在使用该产品和／或服务时，应当适用该单独的隐私权政策</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（二）您通过爱学习产品和／或服务而接入的其他第三方产品和／或服务（包括但不限于爱学习以外的其他交易相对方</span><span style="font-weight:bold">、</span><span style="font-weight:bold">第三方网站以及第三方服务提供者为您提供的产品和／或服务），不适用本政策规定，您应在使用该等第三方提供的产品和／或服务之前，全面</span><span style="font-weight:bold">、</span><span style="font-weight:bold">仔细阅读该等第三方关于其所提供产品和／或服务相关的用户服务协议和隐私权政策，并在确认接受后使用该等第三方提供的产品和／或服务</span><span style="font-weight:bold">。</span><span style="font-weight:bold">我们不对您使用第三方产品和／或服务遭受的损失或给他人造成的损失负责</span><span style="font-weight:bold">。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">二</span><span style="font-weight:bold">、</span><span style="font-weight:bold">个人信息定义及范围</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（一）个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息</span><span style="font-weight:bold">。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（二）个人敏感信息：指一旦泄露</span><span style="font-weight:bold">、</span><span style="font-weight:bold">非法提供或滥用可能危害人身和财产安全，极易导致个人名誉</span><span style="font-weight:bold">、</span><span style="font-weight:bold">身心健康受到损害或歧视性待遇等的个人信息</span><span style="font-weight:bold">。</span><span style="font-weight:bold">包括身份证件号码</span><span style="font-weight:bold">、</span><span style="font-weight:bold">个人生物识别信息</span><span style="font-weight:bold">、</span><span style="font-weight:bold">学籍卡号</span><span style="font-weight:bold">、</span><span style="font-weight:bold">学籍卡I</span><span style="font-weight:bold">D</span><span style="font-weight:bold">、</span><span style="font-weight:bold">银行账号</span><span style="font-weight:bold">、</span><span style="font-weight:bold">财产信息</span><span style="font-weight:bold">、</span><span style="font-weight:bold">行踪轨迹</span><span style="font-weight:bold">、</span><span style="font-weight:bold">交易信息</span><span style="font-weight:bold">、</span><span style="font-weight:bold">1</span><span style="font-weight:bold">4</span><span style="font-weight:bold">岁以下（含）儿童信息等的个人信息</span><span style="font-weight:bold">。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">&nbsp;</span>
      </p>
      <p style="  orphans:0; text-align:justify; text-indent:24pt; widows:0">
        <span style="font-weight:bold">三</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何收集和使用您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们出于本政策所述的以下目的，收集和使用您的个人信息</span><span>。</span><span>如果我们将基于本政策未载明的其他特定目的收集您的信息时，会事先征求您的同意：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（一）帮助您成为我们的用户</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>为使用我们提供的产品和／或服务，您需要在爱学习平台完成注册，成为我们的用户</span><span>。</span><span>在注册过程中，您需要提供基本注册信息，包括您的</span><span style="font-weight:bold">姓名</span><span style="font-weight:bold">、</span><span style="font-weight:bold">手机号码</span><span>，并创建您的账号</span><span>、</span><span>用户名和密码</span><span>。</span><span>如果您拒绝提供上述信息，将不能注册成为我们的用户，并无法登录爱学习平台使用我们提供的产品和／或服务</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（二）</span><a name="_Hlk65771079"><span style="font-weight:bold">向您提供产品和／或服务</span></a>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>为向您提供我们的产品和／或服务，以及向您开放平台的某些功能，我们将收集您的某些个人信息或需要您开放某些权限，这些产品</span><span>、</span><span>服务</span><span>、</span><span>功能以及所需收集的信息、所需开放的权限包括：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1</span><span>.</span><span>所需获取的信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（1）登录：为登录爱学习平台并使用我们提供的产品和／或服务，您需要提供您的</span><span style="font-weight:bold">手机号码</span><span>，或您在爱学习平台注册的</span><span style="font-weight:bold">账号</span><span style="font-weight:bold">、</span><span style="font-weight:bold">密码</span><span>。</span><span>此外，为便于对您的账号进行管理，我们会在平台自动录入您的</span><span style="font-weight:bold">所属机构</span><span>，该信息一经录入不可被更改</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（</span><span>2</span><span>）客服服务：您在使用爱学习提供的产品和／或服务过程中，如果有任何疑问</span><span>、</span><span>意见</span><span>、</span><span>建议，</span><a name="_Hlk65605523"><span>或打算进行举报</span><span>、</span><span>投诉等，</span></a><span>则可以与爱学习客服进行联系</span><span>。</span><span>您通过电话方式与我们联系时，我们会保存您的</span><span style="font-weight:bold">通信或通话记录和内容</span><span>或您留下的</span><span style="font-weight:bold">联系方式</span><span>，以便帮助您解决问题，或记录相关问题的处理方案及结果；同时，我们会获取您的</span><span style="font-weight:bold">手机号码、所属地区及</span><span>您主动留下的</span><span style="font-weight:bold">其他信息（如：联系方式）</span><span>。</span><span>我们的客服会使用您的</span><span style="font-weight:bold">账号信息</span><span>与您核验您的身份</span><span>。</span><span>您有可能会在与我们的客服人员沟通时，视情况需要提供上述信息外的</span><span style="font-weight:bold">其他信息</span><span>，但该等信息均应当出于您自愿提供，我们不会强迫您提供，如您不提供，不会影响您使用爱学习平台的其他功能和服务，但可能对解决您提出的问题产生影响</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>所需开放的权限</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（1）存储权限</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>为了保证应用下载、视频播放的正常使用，我们会申请并访问您的存储权限。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（</span><span>2）设备权限</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>为了识别您的设备</span><span>ID，我们会申请并访问您的设备权限。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（三）向您推荐产品和／或服务</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们可能会基于向您提供更加个性化服务的目的，向您推荐可能感兴趣的内容，包括但不限于向您发出产品和／或服务信息，或通过系统向您展示个性化的第三方推广信息，或者在征得您同意的情况下与我们的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息</span><span>。</span><span>在此过程中，我们及我们的合作伙伴需要获取您的</span><span style="font-weight:bold">姓名</span><span style="font-weight:bold">、</span><span style="font-weight:bold">账号</span><span style="font-weight:bold">、</span><span style="font-weight:bold">手机号码</span><span>信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（四）为您提供安全保护保障</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>您的网络身份标识信息将被用于确认您的软件</span><span>、</span><span>账号正常使用及使用安全</span><span>。</span><span>我们将通过弹出窗口形式询问您是否可以获取相应权限，只有您选择同意后，我们才会为您开启相应权限并接收您的个人信息</span><span>。</span><span>我们将通过以下措施为您提供安全保护保障：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>收集您的设备信息以在您登录及使用爱学习产品和／或服务时确认您的身份：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的</span><span style="font-weight:bold">设备相关信息（设备型号</span><span style="font-weight:bold">、</span><span style="font-weight:bold">操作系统版本</span><span style="font-weight:bold">、</span><span style="font-weight:bold">设备设置</span><span style="font-weight:bold">、</span><span style="font-weight:bold">唯一设备标识符和一些软硬件特征信息）</span><span style="font-weight:bold">、</span><span style="font-weight:bold">设备所在位置相关信息（I</span><span style="font-weight:bold">P</span><span style="font-weight:bold">地址</span><span style="font-weight:bold">、</span><span style="font-weight:bold">G</span><span style="font-weight:bold">PS</span><span style="font-weight:bold">／北斗位置信息以及能够提供相关信息的Wi-</span><span style="font-weight:bold">F</span><span style="font-weight:bold">i接入点</span><span style="font-weight:bold">、</span><span style="font-weight:bold">蓝牙和基站等传感器信息）</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>收集您的日志信息以为您提供便利的服务体验，确保使用安全：当您使用爱学习平台提供的产品和／或服务时，我们会自动收集您对平台服务的详细使用情况，作为有关网络日志保存</span><span>。</span><span>包括：您的</span><span style="font-weight:bold">搜索查询内容</span><span style="font-weight:bold">、</span><span style="font-weight:bold">I</span><span style="font-weight:bold">P</span><span style="font-weight:bold">地址</span><span style="font-weight:bold">、</span><span style="font-weight:bold">浏览器的类型</span><span style="font-weight:bold">、</span><span style="font-weight:bold">电信运营商</span><span style="font-weight:bold">、</span><span style="font-weight:bold">使用的语言</span><span style="font-weight:bold">、</span><span style="font-weight:bold">访问日期和时间</span><span style="font-weight:bold">、</span><span style="font-weight:bold">您访问的网页记录</span><span style="font-weight:bold">、</span><span style="font-weight:bold">通话状态信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>请注意，单独的设备信息</span><span>、</span><span>日志信息等是无法识别特定自然人身份的信息</span><span>。</span><span>如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化</span><span>、</span><span>去标识化处理</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>3.</span><span>为预防</span><span>、</span><span>发现</span><span>、</span><span>调查欺诈</span><span>、</span><span>侵权</span><span>、</span><span>危害安全</span><span>、</span><span>非法或违反与平台或与平台关联公司（我们的关联公司包括北京爱学习博乐教育科技有限公司现在或将来控制</span><span>、</span><span>受控制或与其处于共同控制下的任何公司</span><span>、</span><span>机构以及上述公司或机构的合法权利义务继受人</span><span>。</span><span>其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权</span><span>、</span><span>有投票权的股份</span><span>、</span><span>合同或其他被人民法院认定</span><span>的方式）的协议</span><span>、</span><span>政策或规则的行为，我们可能收集或整合您的</span><span style="font-weight:bold">用户信息</span><span style="font-weight:bold">、</span><span style="font-weight:bold">服务使用信息</span><span style="font-weight:bold">、</span><span style="font-weight:bold">设备信息</span><span style="font-weight:bold">、</span><span style="font-weight:bold">日志信息</span><span>以及我们关联公司</span><span>、</span><span>合作伙伴取得您授权或依据法律</span><span style="font-weight:bold">共享的信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（五）统计和研究的目的</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们会对我们的产品和／或服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示我们的产品和／或服务的整体使用趋势</span><span>。</span><span>如果我们在进行统计的过程中使用到您的个人信息，我们会对您的个人信息进行去标识化及匿名化处理后使用</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（六）整理</span><span style="font-weight:bold">、</span><span style="font-weight:bold">分析</span><span style="font-weight:bold">、</span><span style="font-weight:bold">挖掘和利用</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>对于我们收集到的您的信息，我们将通过技术手段及时进行去标识化</span><span>、</span><span>匿名化处理</span><span>。</span><span>您理解并同意，在不泄露您个人信息的前提下，我们有权对去标识化</span><span>、</span><span>匿名化处理后的数据进行整理</span><span>、</span><span>分析</span><span>、</span><span>挖掘和利用</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（七）征得授权同意的例外</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>根据国家有关法律法规规定，以下情形中，收集</span><span>、</span><span>使用您的个人信息无需事先征得您的授权同意：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>与国家安全</span><span>、</span><span>国防安全有关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2</span><span>.</span><span>与公共安全</span><span>、</span><span>公共卫生</span><span>、</span><span>重大公共利益有关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>3</span><span>.</span><span>与犯罪侦查</span><span>、</span><span>起诉</span><span>、</span><span>审判和判决执行等有关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>4</span><span>.</span><span>出于维护您或其他个人的生命</span><span>、</span><span>财产等重大合法权益但又很难得到您本人同意的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>5</span><span>.</span><span>您自行向社会公众公开的个人信息；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>6</span><span>.</span><span>从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道</span><span>、</span><span>政府信息公开等渠道；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>7</span><span>.</span><span>根据您的要求签订和履行合同所必需的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>8</span><span>.</span><span>用于维护所提供的产品与／或服务的安全稳定运行所必需的，例如发现</span><span>、</span><span>处置产品与／或服务的故障；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>9</span><span>.</span><span>根据法律规定，收集</span><span>、</span><span>使用经去标识化</span><span>、</span><span>匿名化处理的信息，且该等信息无法复原并重新识别个人信息主体的，不属于个人信息，对此类信息的收集及使用将无需另行向您通知并征得您的同意；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1</span><span>0.</span><span>法律法规规定的其他情形</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">四</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何使用</span><span style="font-weight:bold">Cookie</span><span style="font-weight:bold">和同类技术</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（一）</span><span style="font-weight:bold">Cookie</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为C</span><span>ookie</span><span>的小数据文件</span><span>。</span><span>C</span><span>ookie</span><span>通常包含标识符</span><span>、</span><span>站点名称以及一些号码和字符</span><span>。</span><span>借助于C</span><span>ookie</span><span>，网站能够存储您的偏好或购物篮内的商品等数据</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们不会将Cookie用于本政策所述目的之外的任何用途</span><span>。</span><span>您可根据自己的偏好管理或删除</span><span>。</span><span>您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止C</span><span>ookie</span><span>的功能</span><span>。</span><span>但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（二）网站信标和像素标签</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>除C</span><span>ookie</span><span>外，我们还会在网站上使用网站信标和像素标签等其他同类技术</span><span>。</span><span>例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击U</span><span>RL</span><span>，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务</span><span>。</span><span>网站信标通常是一种嵌入到网站或电子邮件中的透明图像</span><span>。</span><span>借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开</span><span>。</span><span>如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（三）Do</span><span style="font-weight:bold"> N</span><span style="font-weight:bold">ot</span><span style="font-weight:bold"> T</span><span style="font-weight:bold">rack（请勿追踪）</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>很多网络浏览器均设有Do</span><span> N</span><span>ot</span><span> T</span><span>rack功能，该功能可向网站发布Do</span><span> N</span><span>ot</span><span> T</span><span>rack请求</span><span>。</span><span>目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求</span><span>。</span><span>但如果您的浏览器启用了Do</span><span> N</span><span>ot</span><span> T</span><span>rack，那么我们的所有网站都会尊重您的选择</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">五</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何共享</span><span style="font-weight:bold">、</span><span style="font-weight:bold">转让</span><span style="font-weight:bold">、</span><span style="font-weight:bold">公开披露您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（一）共享</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们不会向其他任何公司</span><span>、</span><span>组织和个人分享您的个人信息，但以下情况除外：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>我们可能会根据法律法规规定，或按政府主管部门</span><span>、</span><span>司法部门的强制性要求，对外共享您的个人信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>3.</span><span>与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享</span><span>。</span><span>我们只会共享必要的个人信息，且受本政策中所声明目的的约束</span><span>。</span><span>关联公司如要改变个人信息的处理目的，将再次征求您的授权同意</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>4.</span><span>与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供</span><span>。</span><span>我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验</span><span>。</span><span>在这种情况下，这些公司必须遵守我们的数据隐私和安全要求</span><span>。</span><span>我们仅会出于合法</span><span>、</span><span>正当</span><span>、</span><span>必要</span><span>、</span><span>特定</span><span>、</span><span>明确的目的共享您的个人信息，并且只会共享提供产品和／或服务所必要的个人信息</span><span>。</span><span>我们的合作伙伴无权将共享的个人信息用于与产品和／或服务无关的其他用途</span><span>。</span><span>目前，我们的授权合作伙伴包括以下几种类型：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（1）</span><span>供应商</span><span>、</span><span>服务提供商和其他合作伙伴</span><span>。</span><span>我们可能会将您的个人信息共享给支持我们产品</span><span>、</span><span>服务和功能的第三方，这些支持包括身份验证</span><span>、</span><span>安全防范</span><span>、</span><span>数据处理</span><span>、</span><span>客户服务等</span><span>。</span><span>我们共享这些信息的目的是可以实现我们产品和／或服务的核心功能</span><span>。</span><span>出于技术需要，爱学习平台嵌入了以下第三方软件开发工具包（S</span><span>DK</span><span>）：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>a.</span><span>友盟S</span><span>DK</span><span>：平台集成友盟S</span><span>DK</span><span>，友盟S</span><span>DK</span><span>需要收集您的设备M</span><span>ac</span><span>地址</span><span>、</span><span>唯一设备识别码（I</span><span>EME/A</span><span>ndroid</span><span> ID</span><span>/</span><span>IDFA/OPENUDID/GUID</span><span>、S</span><span>IM</span><span>卡I</span><span>MSI</span><span>信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力</span><span>。</span><span>在此过程中，友盟S</span><span>DK</span><span>需要访问您的网络</span><span>、</span><span>获取网络信息</span><span>状态</span><span>、</span><span>访问电话状态</span><span>、</span><span>获取</span><span>W</span><span>i-</span><span>F</span><span>i接入状态以及W</span><span>LAN</span><span>热点信息（友盟官网地址：h</span><span>ttps://www.umeng.com</span><span>）；</span>
      </p>
      <p style=" text-align:justify; text-indent:24pt">
        <span>b.</span><span>保利威视S</span><span>DK</span><span>：平台集成保利威视S</span><span>DK</span><span>，以提供视频播放服务</span><span>。</span><span>为向您提供此项服务</span><span>，保利威视需要访问您的摄像头权限、存储权限（保利威视官网地址：</span><a style="color:#474d6b" href="https://www.polyv.net"><span>h</span><span>ttps://www.polyv.net</span></a><span>）。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（2）</span><span>第三方商家</span><span>。</span><span>如果您在爱学习平台购买的产品和／或服务最终需要由第三方商家提供，我们会将您的订单信息及与交易有关的必要信息与第三方商家共享，来实现您购买产品和／或服务的需求，并促使其可以完成后续的售后服务；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（3）广告</span><span>、</span><span>分析服务类的授权合作伙伴</span><span>。</span><span>除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告</span><span>、</span><span>分析服务的合作伙伴分享</span><span>。</span><span>但我们可能会将使用您的信息而形成的用户画像与提供广告</span><span>、</span><span>分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>对我们与之共享个人信息的公司</span><span>、</span><span>组织和个人，我们会与其签署相应的保密协议，要求他们按照我们的说明</span><span>、</span><span>本政策以及其他任何相关的保密和安全措施来处理个人信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（二）转让</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们不会将您的个人信息转让给任何公司</span><span>、</span><span>组织和个人，但以下情况除外：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>在涉及合并</span><span>、</span><span>收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司</span><span>、</span><span>组织继续受本政策的约束，否则我们将要求该公司</span><span>、</span><span>组织重新向您征求授权同意</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（三）公开披露</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们仅会在以下情况下，公开披露您的个人信息：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>获得您明确同意后；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>基于法律的披露：在法律</span><span>、</span><span>法律程序</span><span>、</span><span>诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <a name="_Hlk65747526"><span style="font-weight:bold">（四）共享</span><span style="font-weight:bold">、</span><span style="font-weight:bold">转让</span><span style="font-weight:bold">、</span><span style="font-weight:bold">公开披露信息时征得授权同意的例外</span></a>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>以下情形中，共享</span><span>、</span><span>转让</span><span>、</span><span>公开披露您的个人信息无需事先征得您的授权同意：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>与国家安全</span><span>、</span><span>国防安全有关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>与公共安全</span><span>、</span><span>公共卫生</span><span>、</span><span>重大公共利益有关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>3.</span><span>与犯罪侦查</span><span>、</span><span>起诉</span><span>、</span><span>审判和判决执行等有关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>4.</span><span>出于维护您或其他个人的生命</span><span>、</span><span>财产等重大合法权益但又很难得到您本人同意的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>5.</span><span>所共享</span><span>、</span><span>转让</span><span>、</span><span>公开披露的信息系您自行向社会公众公开的个人信息；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>6.</span><span>所共享</span><span>、</span><span>转让</span><span>、</span><span>公开披露的信息系从合法公开披露的信息中收集的，如合法的新闻报道</span><span>、</span><span>政府信息公开等渠道；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>7.</span><span>根据您的要求签订和履行合同所必需的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>8.</span><span>用于维护所提供的产品与／或服务的安全稳定运行所必需的，例如发现</span><span>、</span><span>处置产品与／或服务的故障；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>9.</span><span>根据法律规定，共享</span><span>、</span><span>转让</span><span>、</span><span>公开披露</span><span>经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享</span><span>、</span><span>转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>10.</span><span>法律法规规定的其他情形</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">六</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何存储您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们将以以下形式储存收集到的相关个人信息：结构化数据存储</span><span>。</span><span>存储个人信息的服务器放置在中华人民共和国境内</span><span>。</span><span>同时我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求</span><span>。</span><span>例如《中华人民共和国电子商务法》要求商品和服务信息</span><span>、</span><span>交易信息保存时间自交易完成之日起不少于三年；《教育部等六部门关于规范校外线上培训的实施意见》规定，用户行为日志须留存</span><span>1</span><span>年以上</span><span>。</span><span>就爱学习平台服务所涉及的用户行为日志，我们将进行匿名化处理</span><span>。</span><span>我们判断前述期限的标准包括：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（一）完成与您相关的交易目的</span><span>、</span><span>维护相应交易及业务记录</span><span>、</span><span>应对您可能的查询或投诉；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（二）保证我们为您提供服务的安全和质量；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（三）您是否同意更长的留存期间；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（四）是否存在保留期限的其他特别约定</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理（如您为未成年人，在您的个人信息超出保留期间后，我们会按照相关法律法规要求对您的个人信息进行相应处理）</span><span>。</span><span>如因特殊情形无法按照相关要求删除的，我们将对该部分事项向您进行说明</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="-aw-bookmark-end:_Hlk65747526" /><span style="font-weight:bold">七</span><span style="font-weight:bold">、</span><span style="font-weight:bold">我们如何保护您的个人信息</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（一）我们严格按照本政策约定及《中华人民共和国网络安全法》</span><span>、</span><span>《个人信息安全规范》等相关法律法规的规定收集</span><span>、</span><span>使用</span><span>、</span><span>储存和分享您的个人信息</span><span>。</span><span>本政策对个人信息保护相关内容未作明确约定的，以相关法律法规规定为准</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（二）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问</span><span>、</span><span>公开披露</span><span>、</span><span>使用</span><span>、</span><span>修改</span><span>、</span><span>损坏或丢失</span><span>。</span><span>我们会采取一切合理可行的措施，保护您的个人信息</span><span>。</span><span>例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受S</span><span>SL</span><span>加密保护；我们同时对我们网站提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（三）我们会采取一切合理可行的措施，尽量避免收集无关的个人信息</span><span>。</span><span>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（四）互联网并非绝对安全的环境，而且电子邮件</span><span>、</span><span>即时通讯及您与我们其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息，并请您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码</span><span>、</span><span>定期修改密码</span><span>、</span><span>不将自己的账号密码等个人信息透露给他人等</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（五）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性</span><span>。</span><span>但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全</span><span>。</span><span>在不幸发生个人信息安全事件后，我们将按照法律法规的要求并最迟不迟于</span><span>30</span><span>个自然日内向您告知：安全事件的基本情况和可能的影响</span><span>、</span><span>我们已采取或将要采取的处置措施</span><span>、</span><span>您可自主防范和降低风险的建议</span><span>、</span><span>对您的补救措施等</span><span>。</span><span>事件相关情况爱学习将以邮件</span><span>、</span><span>信函</span><span>、</span><span>电话</span><span>、</span><span>推送通知等方式告知您，难以逐一告知您时，我们会采取合理</span><span>、</span><span>有效的方式发布公告</span><span>。</span><span>同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">八</span><span style="font-weight:bold">、</span><a name="_Hlk65758393"><span style="font-weight:bold">您</span></a><span style="font-weight:bold">的权利</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>按照中国相关的法律</span><span>、</span><span>法规</span><span>、</span><span>标准，以及其他国家</span><span>、</span><span>地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（一）查询权</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>您有权查询您的个人信息，法律法规规定的例外情况除外</span><span>。</span><span>如果您想查看您的账户信息，您可以登录爱学习平台，在首页查看所属机构、头像和昵称</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（二）更正权</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <a name="_Hlk46399850"><span>当您有更正信息的需求时，您可以联系爱学习客服进行更正</span><span>。</span></a>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="-aw-bookmark-end:_Hlk46399850" /><span style="font-weight:bold">（三）删除权</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>在以下情形中，您可以向我们提出删除个人信息的要求：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>如果我们处理个人信息的行为违反法律法规；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>如果我们收集</span><span>、</span><span>使用您的个人信息，却未征得您的同意；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>3.</span><span>如果我们处理个人信息的行为违反了与您的约定；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>4.</span><span>如果您不再使用我们的产品或服务，或您注销了账号；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>5.</span><span>如果我们不再为您提供产品或服务；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>当您被从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>您可以通过</span><a name="_Hlk65763004"><span>拨打客服电话联系我们</span></a><span>，</span><a name="_Hlk65763355"><span>我们验证您的身份后，</span></a><span>会帮您删除相关信息</span><span>。</span><span>如平台停止运营或停止提供相关服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（四）撤销权</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>每个业务功能需要一些基本的个人信息才能得以完成（见本政策“三</span><span>、</span><span>我们如何收集和使用您的个人信息”部分相关说明）</span><span>。</span><span>对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意</span><span>。</span><span>您可以通过以下方式自行操作：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>您可以通过修改个人设置的方式撤销授权</span><span>，也</span><span>可以通过拨打客服电话联系我们撤销授权</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息</span><span>。</span><span>但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（五）注销权</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>您随时可申请注销为使用本产品和／或服务而注册的账号</span><span>。</span><span>您可以拨打我们的客服电话要求注销</span><span>。</span><span>在您注销账号前，我们会要求您进行必要的身份验证，包括个人身份</span><span>、</span><span>安全状态</span><span>、</span><span>设备信息等</span><span>。</span><span>您知悉并理解，注销账号的行为是不可逆的行为，在注销账号之后，我们将停止为您提供产品和／或服务，并依据您的要求，删除您的个人信息或对相关信息进行匿名化处理，但法律法规另有规定的除外</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（六）获取个人信息副本</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>您有权获取您的个人信息副本，您可以通过拨打我们的客服电话要求我们向您发送个人信息副本，在对您的身份进行验证核实后，我们会向您发送您的个人信息副本</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（七）约束信息系统自动决策</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>在某些业务功能中，我们可能仅依据信息系统</span><span>、</span><span>算法等在内的非人工自动决策机制作出决定</span><span>。</span><span>如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">（八）响应您的上述请求</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份</span><span>。</span><span>我们会在验证核实您的身份后处理您的请求，并在</span><span>15</span><span>个工作日内或法律法规规定的期限内作出答复</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">对于您合理的请求，我们原则上不收取费用，但对多次重复</span><span style="font-weight:bold">、</span><span style="font-weight:bold">超出合理限度的请求，我们将视情况收取一定成本费用</span><span style="font-weight:bold">。</span><span style="font-weight:bold">对于那些无端重复</span><span style="font-weight:bold">、</span><span style="font-weight:bold">需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）</span><span style="font-weight:bold">、</span><span style="font-weight:bold">给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝</span><span style="font-weight:bold">。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">在以下情形中，按照法律法规的要求，我们将无法响应您的上述请求：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>1.</span><span>与我们履行法律法规规定的义务相关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>2.</span><span>与国家安全</span><span>、</span><span>国防安全直接相关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>3.</span><span>与公共安全</span><span>、</span><span>公共卫生</span><span>、</span><span>重大公共利益直接相关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>4.</span><span>与刑事侦查</span><span>、</span><span>起诉</span><span>、</span><span>审判和执行判决等直接相关的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>5.</span><span>我们有充分证据表明您存在主观恶意或滥用权利的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>6.</span><span>出于维护您或其他个人的生命</span><span>、</span><span>财产等重大合法权益的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>7.</span><span>响应您的请求将导致您或其他个人</span><span>、</span><span>组织的合法权益受到严重损害的；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>8.</span><span>涉及商业秘密的</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">九</span><span style="font-weight:bold">、</span><span style="font-weight:bold">您的个人信息如何在全球范围转移</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内</span><span>。</span><span>如果需要将您的个人信息转移到境外，我们将另行获得您的授权同意，在此情况下我们会依据本政策对您的个人信息进行充分保护</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">十</span><span style="font-weight:bold">、</span><span style="font-weight:bold">本政策的修订与更新</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>我们有权不时对本政策进行修订</span><span>、</span><span>更新，我们会将修订</span><span>、</span><span>更新后的本政策以适当的可以为您所知的方式进行公布（包括但不限于公布在官方网站</span><span>、</span><span>移动应用</span><span>、</span><span>电脑客户端等平台上），如果您不同意修订</span><span>、</span><span>更新</span><span>后的本政策的，您应当停止使用爱学习产品和／或服务；如果在我们修订</span><span>、</span><span>更新</span><span>本政策并公布后，您继续使用爱学习产品和／或服务的，则视为您同意修订</span><span>、</span><span>更新</span><span>后的本政策</span><span>。</span><span />
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>对于可能会导致您在本政策下权益实质减损的重大变更，我们还会提供更为显著的通知（包括但不限于通过应用内弹窗</span><span>、</span><span>电话</span><span>、</span><span>短信的方式进行意见征集</span><span>、</span><span>公告通知等）</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">上述重大变更包括但不限于：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（一）我们的服务模式发生重大变化：如处理个人信息的目的</span><span>、</span><span>处理的个人信息类型</span><span>、</span><span>个人信息的使用方式等；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（二）我们在所有权结构</span><span>、</span><span>组织架构等方面发生重大变化：如业务调整</span><span>、</span><span>破产并购等引起的所有者变更等；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（三）个人信息共享</span><span>、</span><span>转让或公开披露的主要对象发生变化；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（四）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（五）我们负责处理个人信息安全的责任部门</span><span>、</span><span>联络方式及投诉渠道发生变化；</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（六）个人信息安全影响评估报告表明存在高风险时</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">十一</span><span style="font-weight:bold">、</span><span style="font-weight:bold">法律适用及争议解决</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（一）本政策之订立</span><span>、</span><span>生效</span><span>、</span><span>解释</span><span>、</span><span>修订</span><span>、</span><span>补充</span><span>、</span><span>终止</span><span>、</span><span>执行与争议解决等任何方面均适用中华人民共和国大陆地区法律</span><span>。</span><span>如法律无相关规定的，参照商业惯例及／或行业惯例</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>（二）您因使用爱学习产品和／或服务所产生之有关争议，我们将与您协商解决</span><span>。</span><span>协商不成时，任何一方均应向爱学习所在地有管辖权的人民法院提起诉讼</span><span>。</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>&nbsp;</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">十二</span><span style="font-weight:bold">、</span><span style="font-weight:bold">您如何联系我们</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span>如果您有与本政策及个人信息保护相关的任何疑问</span><span>、</span><span>意见</span><span>、</span><span>投诉和建议，或打算进行信息更正、删除、撤销授权、注销账号、获取个人信息副本等操作，请通过以下方式联系我们</span><span>，</span><span>我们将在</span><span>15</span><span>个工作日内作出反馈：</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">平台运营主体名称：北京爱学习博乐教育科技有限公司</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">注册地址：北京市海淀区北四环中路</span><span style="font-weight:bold">283</span><span style="font-weight:bold">号</span><span style="font-weight:bold">11</span><span style="font-weight:bold">层</span><span style="font-weight:bold">1105</span><span style="font-weight:bold">室</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">联系地址：北京市海淀区学院路街道学清路</span><span style="font-weight:bold">10</span><span style="font-weight:bold">号学清嘉创大厦</span><span style="font-weight:bold">10</span><span style="font-weight:bold">层</span>
      </p>
      <p style="  text-align:justify; text-indent:24pt">
        <span style="font-weight:bold">客服电话：</span><a name="_Hlk65601740"><span style="font-weight:bold">400-898-1009</span></a><a name="_Hlk78911764"><span style="-aw-bookmark-end:_Hlk65601740" /><span style="font-weight:bold">、</span><span style="font-weight:bold">400-898-9909</span></a>
      </p>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less">
@import '~@/static/css/base.less';

.protocol-modal {
  .ant-modal-body {
    color: @gray-2!important;
    line-height: 2;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 10px 40px 10px;

    .modal-body-main {
      padding: 30px 30px 0 30px;
      max-height: 80vh;
      overflow: auto;
    }

    a {
      color: @gray-2!important;
    }
  }
}
</style>